import { IChoice } from "@components/inputs/DropDownMenu";
import { Country } from "./localisation";

export const hubs: { [key in Country]: IChoice[] } = {
    GB: [
        { value: 'LDN', label: 'Cricklewood', enabled: true },
        { value: 'GLH', label: 'Greenlight', enabled: true },
    ],
    AU: [
        { value: 'ACT', label: 'ACT', enabled: true },
        { value: 'NSW', label: 'NSW', enabled: true },
        { value: 'QLD', label: 'QLD', enabled: true },
        { value: 'SA', label: 'SA', enabled: true },
        { value: 'VIC', label: 'VIC', enabled: true },
        { value: 'WA', label: 'WA', enabled: true },
    ]
};

// GB return-location dropdowns (cancellation V1/V2, exchange): the "Blank" choice, which clears
// the vehicle's Fleetio `vehicle_location` field. An empty value means "don't write", so clearing
// needs its own value. Must match CLEAR_VEHICLE_LOCATION in src/py/processors/vehicles.py.
export const CLEAR_VEHICLE_LOCATION = "__BLANK__";

export const clearVehicleLocationChoice: IChoice = {
    value: CLEAR_VEHICLE_LOCATION,
    label: 'Blank (clear location)',
    enabled: true,
};
